import { ResponsivePie } from "@nivo/pie";
import { useEffect, useState } from "react";
import formatShort from "../../../utils/formatShort";
import revenueByDept from "../../../utils/revenueByDept";
import servicesByType from "../../../utils/servicesByType";
import { REACT_APP_ARPS_BASE_URL } from "../../../utils/urls";
const ServiceChart = ({ startDate, endDate }: any) => {
  const [services, setServices] = useState<any>([]);
  const [loading, setLoading] = useState(false);

  const fetchServices = async () => {
    setLoading(true);
    const response = await fetch(
      `${REACT_APP_ARPS_BASE_URL}/service?start=${startDate}&end=${endDate}`
    );
    const data = await response.json();

    const mean = servicesByType(data);

    setServices(mean);
    setLoading(false);
  };

  useEffect(() => {
    fetchServices();
  }, [startDate]);

  return (
    <ResponsivePie
      data={services}
      margin={{ top: 80, right: 10, bottom: 10, left: 10 }}
      innerRadius={0.5}
      padAngle={0.7}
      cornerRadius={3}
      activeOuterRadiusOffset={8}
      borderWidth={1}
      borderColor={{
        from: "color",
        modifiers: [["darker", 0.2]],
      }}
      valueFormat={(value: any) => `${formatShort(value)}`}
      arcLinkLabelsSkipAngle={10}
      arcLinkLabelsTextColor="#333333"
      arcLinkLabelsThickness={2}
      arcLinkLabelsColor={{ from: "color" }}
      arcLabelsSkipAngle={10}
      arcLabelsTextColor={{
        from: "color",
        modifiers: [["darker", 2]],
      }}
      defs={[
        {
          id: "dots",
          type: "patternDots",
          background: "inherit",
          color: "rgba(255, 255, 255, 0.3)",
          size: 4,
          padding: 1,
          stagger: true,
        },
        {
          id: "lines",
          type: "patternLines",
          background: "inherit",
          color: "rgba(255, 255, 255, 0.3)",
          rotation: -45,
          lineWidth: 6,
          spacing: 10,
        },
      ]}
      fill={[
        {
          match: {
            id: "ruby",
          },
          id: "dots",
        },
        {
          match: {
            id: "c",
          },
          id: "dots",
        },
        {
          match: {
            id: "go",
          },
          id: "dots",
        },
        {
          match: {
            id: "python",
          },
          id: "dots",
        },
        {
          match: {
            id: "scala",
          },
          id: "lines",
        },
        {
          match: {
            id: "lisp",
          },
          id: "lines",
        },
        {
          match: {
            id: "elixir",
          },
          id: "lines",
        },
        {
          match: {
            id: "javascript",
          },
          id: "lines",
        },
      ]}
      legends={[
        {
          anchor: "right",
          direction: "column",
          justify: false,
          translateX: 140,
          translateY: 0,
          itemWidth: 120,
          itemHeight: 20,
          itemsSpacing: 0,
          symbolSize: 20,
          itemDirection: "left-to-right",
        },
      ]}
    />
  );
};

export default ServiceChart;
